import Container from './../dom/Container';
export default class Grid extends Container {

    constructor(elementParent, attrs) {
        super(elementParent, attrs);
    }
    
}


// WEBPACK FOOTER //
// ./src/AAF/lib/gui/components/Grid.js